<template>
  <v-container fluid>
    <!-- 定期試験情報表示用 -->
    <v-row dense v-if="testResultActiveFlg == true">
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center black--text" outlined>
          定期試験のきろく
        </v-card>
      </v-col>
    </v-row>
    <v-row dense class="mt-4 mb-4" v-if="testResultActiveFlg == true">
      <v-col cols="12" justify="center">
        <v-card class="text-center" color="white">
          <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4">
              <v-autocomplete
                v-model="selectNendo"
                label="年度指定"
                placeholder="年度指定"
                :items="nendoList"
                outlined
                dense
                hide-details="auto"
                background-color="white"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense v-if="testResultActiveFlg == true">
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="examList"
          :items-per-page="-1"
          hide-default-header
          hide-default-footer
          disable-sort
          mobile-breakpoint="0"
          :loading="isListLoding"
          loading-text="読込中"
        >
          <template #[`item.recode`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-toolbar color="primary" dark dense @click="toggleDetails(item)">
                  <v-toolbar-title class="subtitle-1">
                    {{ item.sikenNm }}
                    <span v-if="item.newFlg" class="text-caption font-weight-bold red--text">
                      NEW
                    </span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-icon>{{ item.displayFlg ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-toolbar>
              </v-col>
            </v-row>
            <div>
              <v-expand-transition>
                <v-card v-if="item.displayFlg == true">
                  <v-card-text  v-if="userKbn == '1'">
                    {{ item.userNm }}さん
                  </v-card-text>
                  <v-card-text>
                    個人総合点：{{ Math.trunc(item.totalSeiseki) }}
                  </v-card-text>
                  <v-card-text>
                    個人総合順位：{{ item.classRank }}/{{ item.classDenominator }}
                  </v-card-text>
                  <v-card-text>
                    <v-simple-table dense>
                      <thead>
                        <tr>
                          <th cols="6" class="text-left">科目名</th>
                          <th cols="6" class="text-right">素点</th>
                          <th cols="6" class="text-right">科目平均</th>
                          <th cols="6" class="text-right">科目順位</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="subject in filteredSubjects(item)" :key="subject.key">
                          <td>{{ subject.kamokuNm }}</td>
                          <td class="text-right">{{ subject.seiseki }}</td>
                          <td class="text-right">{{ subject.kamokuAve }}</td>
                          <td class="text-right">{{ subject.rank }}<span v-if="subject.rank !== null && subject.denominator !== null">/</span>{{ subject.denominator }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-expand-transition>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- 通知表 -->
    <v-row dense v-if="reportPublishActiveFlg == true">
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center black--text" outlined>
          通知表
        </v-card>
      </v-col>
    </v-row>
    <v-row dense v-if="reportPublishActiveFlg == true">
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers2"
          :items="reportList"
          :items-per-page="-1"
          hide-default-header
          hide-default-footer
          disable-sort
          mobile-breakpoint="0"
          :loading="isListLoding"
          loading-text="読込中"
        >
          <template #[`item.recode`]="{ item }">
            <v-row dense>
              <v-col cols="6" class="d-flex justify-end">
                <span>
                  {{ item.nendo }}年度
                </span>
                <span>
                  {{ item.gakki }}  
                </span>
                <span v-if="item.gakkiCd != '9'">
                  学期
                </span>
              </v-col>
              <v-col cols="6" class="d-flex justify-start">
                <span v-if="userKbn == '1'">
                  {{ item.userNm }}さん
                </span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click="onClickDwonload(item)">
                      <v-icon color="black">mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>帳票をダウンロードする。</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import '@uppy/core/dist/style.css';
import { httpsCallable, getFunctions } from 'firebase/functions';
import { saveAsCommon } from '../../common';
export default {
  data() {
    return {
      // 項目表示制御
      testResultActiveFlg: false,
      reportPublishActiveFlg: false,
      // 定期試験情報表示用
      selectNendo: "",
      nendoList: [],
      userKbn : "",
      examList: [],
      headers: [
        { text: "", value: "recode" },
        { text: "年度", value: "nendo", cellClass: "d-none", filter: this.nendoFilter },
      ],

      // 定期試験情報表示用
      reportList: [],
      headers2: [
        { text: "", value: "recode" },
      ],
    };
  },
  // 初期表示時データ読み込み
  async created() {
    this.testResultActiveFlg = this.$root.testResultActiveFlg;
    this.reportPublishActiveFlg = this.$root.reportPublishActiveFlg;
    await this.load();
  },
  methods: {
    // 年度フィルタ(定期試験)
    nendoFilter(value) {
      if (!this.selectNendo) {
        return true;
      }
      return value.toString().includes(this.selectNendo);
    },
    // 年度フィルタ(通知表)
    nendoFilter2(value) {
      if (!this.selectNendo2) {
        return true;
      }
      return value.toString().includes(this.selectNendo2);
    },
    async load() {
      // ローディング表示
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = 'asia-northeast1';
      const schoolAidHomeLogined = httpsCallable(functions, 'schoolAidHomeLogined');
      // 定期試験情報取得
      await schoolAidHomeLogined({funcName: 'loadRegularExamHistory'}).then((ret) => {
        this.userKbn = ret.data.userKbn;
        this.selectNendo = ret.data.tounendo;
        this.nendoList = ret.data.nendoList;
        this.examList = ret.data.examList;
      });
      // 通知表情報取得
      await schoolAidHomeLogined({funcName: 'loadGradeReportHistory'}).then((ret) => {
        this.reportList = ret.data.reportList;
      });

      // ローディング非表示
      this.$root.loading = false;
    },
    // 明細の折り畳み制御
    toggleDetails(item) {
      item.displayFlg = !item.displayFlg;
    },
    // 科目と点数表示制御
    filteredSubjects(item) {
      const subjects = [];
      for (let i = 1; i <= 32; i++) {
        if (item['kamokuNm' + i] !== null || item['seiseki' + i] !== null || item['kamokuAve' + i] !== null || item['rank' + i] !== null || item['denominator' + i] !== null) {
          subjects.push({
            key: i,
            kamokuNm: item['kamokuNm' + i],
            seiseki: item['seiseki' + i],
            kamokuAve: item['kamokuAve' + i],
            rank: item['rank' + i],
            denominator: item['denominator' + i],
          });
        }
      }
      return subjects;
    },
    // 成績帳票ダウンロード
    async onClickDwonload(item) {
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      var param = {
        funcName: "getSeisekiReportLink",
        userId: item.userId,
        reportId: item.reportId,
        repoCd: item.repoCd,
      }
      var retParam = {};
      await schoolAidHomeLogined(param).then((ret) => {
        retParam.url = ret.data.url;
        retParam.fileName = ret.data.fileName;
      });

      saveAsCommon(retParam.url, retParam.fileName);
    },
  },
};
</script>

<style scoped lang="scss">  
  tbody {
     tr:hover {
        background-color: transparent !important;
     }
  }
</style>